/*eslint-disable jsx-a11y/anchor-is-valid*/
import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { ReactComponent as AlertIcon } from 'assets/icons/alert15.svg'
import { useQueryParams } from 'hooks/useQueryParams'
import { redirectToFrontendDomainIfNecessary } from 'utils/workspaceDomainUtils'
import { FORCE_DEFAULT_WORKSPACE_PARAM } from 'screens/LoginOrSignup/constants'

import Styles from './CustomDomainWarning.module.scss'

export const CustomDomainWarning = () => {
  const { domain: customDomain } = useQueryParams()

  const history = useHistory()

  const onGoToBlaze = useCallback(() => {
    const searchParams = new URLSearchParams(history.location.search)
    searchParams.delete('domain')
    searchParams.set(FORCE_DEFAULT_WORKSPACE_PARAM, 'true')
    redirectToFrontendDomainIfNecessary({ searchParamsOvewrite: searchParams })
    history.push({ search: searchParams.toString() })
  }, [history])

  return (
    <>
      {customDomain && (
        <div className={Styles.warningBox}>
          <AlertIcon />
          <div>
            <p>
              You are logging in to Blaze at <b>{customDomain}</b>.
            </p>
            <p>
              If this is not what you want, you can <a onClick={onGoToBlaze}>go to blaze.ai</a>.
            </p>
          </div>
        </div>
      )}
    </>
  )
}
